import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class DeleteKundorderCommand extends BasicCommand<DeleteKundorderCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<DeleteKundorderCommand>;
    kundorderId: number;

    constructor(kundorderId: number) {
        super("DeleteKundorderCommand", "kundorder", CommandType.Delete);
        this.kundorderId = kundorderId;
    }

}
